import { RemoveRoleClaimType } from "../../types/Role";
import { post } from "../../utils/axios-config";
import { ROLES_REMOVE_CLAIM } from "../../utils/constants";

export const removeRoleClaim = async (data: RemoveRoleClaimType) => await post<RemoveRoleClaimType, string>(ROLES_REMOVE_CLAIM, data);